import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatIconModule } from '@angular/material/icon';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { AccountSharedModule } from "apps/account/src/account-shared";
import { ReportBadgeComponent } from "./report-badge.component";


@NgModule({
    declarations: [
        ReportBadgeComponent
    ],
    imports: [
        CommonModule,
        AccountSharedModule,
        MatIconModule,
        NgbTooltipModule
    ],
    exports: [
        ReportBadgeComponent
    ]
})
export class ReportBadgeModule {
    constructor() {
    }
}

